/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'organization-file-document-export': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M8.125 13.125h8.231l-1.612 1.619.881.881L18.75 12.5l-3.125-3.125-.881.881 1.612 1.619H8.125v1.25zM13.75 8.75v-2.5a.625.625 0 00-.181-.444L9.194 1.431a.625.625 0 00-.444-.181H2.5c-.69 0-1.25.56-1.25 1.25v15c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25v-1.25H12.5v1.25h-10v-15h5v3.75c0 .69.56 1.25 1.25 1.25h3.75v1.25h1.25zm-5-2.5V2.756l3.494 3.494H8.75z" _fill="#000" fill-rule="evenodd"/>'
  }
})
